export const FETCH_GENRE_REQUEST = "FETCH_GENRE_REQUEST";
export const FETCH_GENRE_SUCCESS = "FETCH_GENRE_SUCCESS";
export const FETCH_GENRE_ERROR = "FETCH_GENRE_ERROR";

export const DELETE_SONG_FROM_GENRE_REQUEST = "DELETE_SONG_FROM_GENRE_REQUEST";
export const DELETE_SONG_FROM_GENRE_ERROR = "DELETE_SONG_FROM_GENRE_ERROR";
export const DELETE_SONG_FROM_GENRE_SUCCESS = "DELETE_SONG_FROM_GENRE_SUCCESS";
export const DELETE_SONG_FROM_GENRE_RESET = "DELETE_SONG_FROM_GENRE_RESET";
